import { DataTable } from '@juvare/common-data-table-ui/DataTable';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Divider, Paper, useMediaQuery } from '@mui/material';
import React from 'react';
import { ListPagination } from '../../../alerts/components/AlertsList/components/ListPagination';
import { ListContent, ListHeader } from './components';
export const NotificationsList = (props) => {
    var _a;
    const upLgScreen = useMediaQuery((theme) => theme.breakpoints.up('lg'));
    return (React.createElement(React.Fragment, null,
        React.createElement(DataTable, Object.assign({}, props, { title: props.title, localActions: props.localActions, columns: [{ cellField: 'subject' }], customTableSurfaceComponent: OutlinedPaper, customTableContentComponent: Empty, customTablePaginationContentComponent: Empty, customContentElement: React.createElement(Box, { sx: {
                    width: 'calc(100% + 2px)',
                    mt: '-8px',
                    ml: '-1px',
                    backgroundColor: props.content ? 'background.paper' : themeColors.background,
                } },
                React.createElement(Paper, { variant: 'outlined', sx: {
                        height: '8px',
                        mb: 2,
                        borderTopLeftRadius: 0,
                        borderTopRightRadius: 0,
                        borderTop: 'none',
                    } }), (_a = props.content) !== null && _a !== void 0 ? _a : (React.createElement(Box, { sx: { display: 'grid', gridTemplateColumns: upLgScreen ? 'auto 1fr' : 'auto', gap: 2 } },
                React.createElement(Paper, { variant: 'outlined', sx: { width: upLgScreen ? 420 : 'auto' } },
                    React.createElement(ListHeader, { dataTableProps: props }),
                    React.createElement(Divider, null),
                    React.createElement(ListContent, { dataTableProps: props, noNotificationsLabel: props.noNotificationsLabel }),
                    React.createElement(ListPagination, Object.assign({}, props))),
                upLgScreen && (React.createElement(Paper, { variant: 'outlined', sx: { alignSelf: 'start', overflowX: 'hidden' } }, props.children))))) }))));
};
export const OutlinedPaper = ({ children }) => (React.createElement(Paper, { variant: 'outlined', sx: { borderBottomLeftRadius: 0, borderBottomRightRadius: 0, borderBottom: 'none' } }, children));
export const Empty = () => null;
